<template>
  <!-- <v-container> -->
    <v-card>
      <v-card-text>
        <v-row class="bm-0 mb-0 pb-0">
          <v-col cols="12">
            <v-card-subtitle class="ml-2">
              <h2 class="text-uppercase indigo--text">
                {{ currentUser.nombre }} {{ currentUser.primer_apellido }} {{ currentUser.segundo_apellido }}
              </h2>
              <h4 class="text-uppercase" style="color: #616161">
                {{ currentUser.roles[0].descripcion }}
              </h4>
              <v-btn
                small
                class="white--text"
                style="float: right; margin-top: -39px;"
                color="#607D8B"
                @click="$router.push({ name:'Tocas' })"
              >
                Panel de Tocas
              </v-btn>
              <v-divider class="mt-1"/>
            </v-card-subtitle>
          </v-col>
        </v-row>
        <v-toolbar-title style="background-color:#1D2E4B;height: 45px; border-radius: 5px;">
          <div class="text-center mb-1 ml-5"  style="color: white;margin-top: 8px;">
            <span><b> {{ titleDocumentos }}</b> </span>
          </div>
        </v-toolbar-title>
        <v-container fluid>
          <v-row>
            <v-col cols="6"></v-col>
            <v-col cols="6">
              <v-select
                class="mt-1 mb-3"
                :items="items_status"
                item-text="text"
                item-value="value"
                return-object
                label="Estatus"
                v-model="status"
                @change="getPendientes()"
              ></v-select>
            </v-col>
          </v-row>
          <v-data-table
            dense
            :headers="headers"
            :items="listPendientes"
            item-key="id"
            light
            actions
            :loading="loading"
            :page.sync="page"
            :items-per-page="per_page_table"
            hide-default-footer
            @page-count="pageCount = $event"
            no-data-text="No hay documentos por mostrar"
          >
            <template v-slot:[`item.toca`]="{ item }">
             <span>
              {{ item.documento.apelacion.toca.numero }}/{{ item.documento.apelacion.toca.anio }}
             </span>
            </template>
            <template v-slot:[`item.documento`]="{ item }">
             <span v-if="item.documento.leyenda">
              {{ item.documento.leyenda }}
             </span>
             <span v-else>
              {{ item.documento.tipo_documento.nombre }}
             </span>
            </template>
            <template v-slot:[`item.apelacion`]="{ item }">
              <span v-if="item.documento.apelacion.tipo_apelacion">{{ item.documento.apelacion.tipo_apelacion.nombre}}
              </span>
            </template>
            <template v-slot:[`item.firmado`]="{ item }">
              <v-icon
                v-if="item.firmado == 0"
                class="mr-2"
                color="grey"
              >mdi-minus</v-icon>
              <v-icon
                v-if="item.firmado == 1"
                class="mr-2"
                color="green"
              >mdi-check-bold</v-icon>
            </template>
            <template v-slot:[`item.evidencia`]="{ item }">
              <v-icon
                v-if="!item.documento.url_evidencia"
                class="mr-2"
                color="grey"
              >mdi-minus</v-icon>
              <v-icon
                v-else
                class="mr-2"
                color="green"
              >mdi-check-bold</v-icon>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <!-- <v-btn x-small color="pink" dark @click="showDocument(item)">
                <v-icon small dark class="mr-2">mdi-file</v-icon>
                  Ver&nbsp;&nbsp;
              </v-btn> -->
              <v-btn
                x-small
                class="white--text mr-2"
                color="#607D8B"
                @click="showFirmantes(item)"
              >
                VER FIRMANTES&nbsp; <v-icon x-small>
                  mdi-file-document-edit
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination
              v-if="pagination.total > 1"
              v-model="pagination.current"
              :length="pagination.total"
              :total-visible="7"
              @input="onPageChange"
              color="#1D2E4B"
            ></v-pagination>
          </div>
        </v-container>
      </v-card-text>
      <v-dialog 
        v-if="dialogFirmantes"
        v-model="dialogFirmantes" 
        persistent 
        max-width="900px"
      >
        <Firmantes :documento_id="documento_id" @close="closeFirmantes"/>
      </v-dialog>
    </v-card>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";
  import Firmantes from "@/components/Firmantes";

  export default {
    components: {
      Firmantes
    },
    data(){
      return {
        magistrado:'',
        magistrados: [],
        magistrados_ids: [],
        loading: false,
        dialogFirmantes: false,
        currentApelacion:'',
        page: 1,
        pageCount: 0,
        itemsPerPage: 20,
        per_page_table: 20,
        listPendientes:[],
        documento_id: '',
        apelacion: {},
        pagination: {
          current: 1,
          total: 0
        },
        status: { "text": "PENDIENTES DE FIRMA", "value": 2, "align": "", "sortable": true, "width": "" },
        headers: [
        { text: 'TOCA', value: 'toca' },
        { text: 'DOCUMENTO', value: 'documento' },
        // { text: 'TIPO DE DOCUMENTO', value: 'documento.tipo_documento.nombre', sortable: false },
        { text: 'FIRMADO', value: 'firmado', sortable: false , align: 'center'},
        { text: 'EVIDENCIA', value: 'evidencia', sortable: false, align: 'center' },
        { text: 'ACCIONES', value: 'action', sortable: false },
      ],
      items_status: [
          { text: "PENDIENTES DE FIRMA", value: 2, align: "", sortable: true, width: '' },
          { text: "FIRMADOS", value: 1, align: "", sortable: true, width: '' },
          { text: "TODOS MIS DOCUMENTOS", value: 0, align: "", sortable: true, width: '' }
        ],
      }
    },
    computed: {
      titleDocumentos () {
        if (this.status.value == 2) {
          return 'DOCUMENTOS PENDIENTES DE FIRMA'
        } else if (this.status.value == 1) {
          return 'DOCUMENTOS FIRMADOS'
        } else if (this.status.value == 0) {
          return 'TODOS MIS DOCUMENTOS'
        }
      },
      ...mapGetters([
          "currentUser",
        ]),
    },
    // watch: {
    //   status: function (val) {
    //     this.pagination.current = 1;
    //     this.getPendientes()
    //   },
    // },
    mounted() {
      // const currentApelacion = JSON.parse(localStorage.getItem('currentApelacion'));
      // if(currentApelacion){
      //   localStorage.removeItem('currentApelacion');
      // }
      this.getPendientes()
    },
    methods:{
      getPendientes(){
        this.listPendientes = []
        this.loading = true
        this.$store.dispatch("GET_PENDIENTES_FIRMAR",  {
          url: "/multifirma/pendientes/" + this.currentUser.id,
          params: {
            page: this.pagination.current,
            firmado: this.status.value
          }
        }).then(response => {
            this.loading = false
            this.listPendientes = response.data.data.pendientes.data
            this.pagination.current = response.data.data.pendientes.current_page;
            this.pagination.total = response.data.data.pendientes.last_page;
            this.per_page_table = response.data.data.pendientes.per_page;
        })
        .catch(error => {
          console.log(error);
        });
      },
      showDocument(item){
        localStorage.setItem("currentDocument", JSON.stringify( item.documento_id ));
        this.$router.push('/documento/firma')
      },
      showFirmantes(item){
        this.documento_id = item.documento_id
        this.dialogFirmantes = true
        // localStorage.setItem("currentDocument", JSON.stringify( item.id ));
        // this.$router.push({ name:'DocumentoFirma' })
      },
      closeFirmantes (val) {
        // VAL 2 SIGNIFICA Q FUE FRIMADO O GENERADA LA EVIDENCIA (SIGNED DE DOCUMENTOS)
        // if (val === 'reloadPage' ) {
        //   this.getPendientes()
        // }
        // this.$refs.form.resetValidation()
        this.dialogFirmantes = false
        this.getPendientes()
        // this.documento_id = ''
      },
      onPageChange() {
        this.getPendientes();
      },
    }
  }
  </script>
